import React, { useState } from "react";
import PropTypes from "prop-types";
import MoreMenu from "shared/components/inputs/menu/MoreMenu";
import { MenuItem } from "@szhsin/react-menu";
import ProjectDrawer from "./ProjectDrawer";
import env from "react-dotenv";
import Folder from "shared/components/utils/icons/Folder";
import Clock from "shared/components/utils/icons/Clock";
import External from "shared/components/utils/icons/External";
import GenericSidebarPortal from "shared/components/feedback/modals/common/GenericSidebarPortal";
import { useCrypto } from "shared/hooks/crypto/useCrypto";
import usePageActionPermission from "shared/hooks/access/usePageActionPermission";
import { ButtonLink, useStyles } from "./More.styles";

export default function More(props) {
    const classes = useStyles();
    const { encrypt } = useCrypto();
    const [sidebarProjectId, setSidebarProjectId] = useState(null);
    const hasProjectActionsPermission = usePageActionPermission(
        "AC_VIEW_PROJECT_ACTION"
    );
    const { project } = props;

    const handleCloseDrawer = () => {
        setSidebarProjectId(null);
    };

    const handleViewProjectClick = (projectId) => {
        if (Number.parseInt(projectId) > 1) {
            setSidebarProjectId(projectId);
        }
    };

    const menuOptions = [
        <MenuItem
            key={0}
            onClick={() => handleViewProjectClick(project.jobId)}
            disabled={props.infoDisabled}
        >
            <Folder size="16" />
            <span className={classes.itemLabel}>View Project Information</span>
        </MenuItem>,
        <MenuItem
            key={1}
            className="noPadding"
            hideItem={!hasProjectActionsPermission}
        >
            <ButtonLink
                href={`${globalThis.config.routes.allocation}?filters=${encrypt(
                    "jobId=" + project.jobId
                )}`}
                target="_blank"
                rel="noreferrer"
            >
                <Clock size="16" />
                <span className={classes.itemLabel}>
                    View Project Allocations
                </span>
            </ButtonLink>
        </MenuItem>,
        <MenuItem
            key={2}
            className="noPadding"
            hideItem={!hasProjectActionsPermission}
        >
            <ButtonLink
                href={
                    "/redirectto?url=" +
                            env.BESTWORK_REACT_REPORTER10_LINK +
                            "job/JobReport.aspx?JobID=" +
                            project.jobId + 
                            "&env=" + env.ENVIRONMENT_NAME + "&vpn=true"
                }
                target="_blank"
                rel="noreferrer"
            >
                <External size="16" />
                <span className={classes.itemLabel}>
                    View Project Dashboard
                </span>
            </ButtonLink>
        </MenuItem>,
    ];

    return (
        <>
            {sidebarProjectId && (
                <GenericSidebarPortal
                    open={true}
                    content={<ProjectDrawer projectId={sidebarProjectId} />}
                    onClose={handleCloseDrawer}
                />
            )}
            <MoreMenu
                alwaysVisible={props.visible}
                direction={props.direction}
                portal={false}
            >
                {menuOptions}
            </MoreMenu>
        </>
    );
}

More.propTypes = {
    project: PropTypes.shape({
        jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    infoDisabled: PropTypes.bool,
    visible: PropTypes.bool,
    direction: PropTypes.string,
};
